var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.59375 10.547H16.4062C16.8379 10.547 17.1875 10.1974 17.1875 9.76578V8.98453C17.1875 8.55289 16.8379 8.20328 16.4062 8.20328H8.59375C8.16211 8.20328 7.8125 8.55289 7.8125 8.98453V9.76578C7.8125 10.1974 8.16211 10.547 8.59375 10.547ZM7.8125 14.4533C7.8125 14.8849 8.16211 15.2345 8.59375 15.2345H16.4062C16.8379 15.2345 17.1875 14.8849 17.1875 14.4533V13.672C17.1875 13.2404 16.8379 12.8908 16.4062 12.8908H8.59375C8.16211 12.8908 7.8125 13.2404 7.8125 13.672V14.4533ZM12.5 20.3678C11.6982 20.3678 10.8965 20.1208 10.2119 19.6261L0 12.2492V22.6564C0 23.9508 1.04932 25.0002 2.34375 25.0002H22.6562C23.9507 25.0002 25 23.9508 25 22.6564V12.2492L14.7881 19.6261C14.1035 20.1203 13.3018 20.3678 12.5 20.3678ZM24.1021 7.95669C23.6699 7.61783 23.2603 7.29898 22.6562 6.84292V4.68765C22.6562 3.39322 21.6069 2.3439 20.3125 2.3439H16.5259C16.3774 2.23648 16.2393 2.13589 16.0845 2.02359C15.2637 1.42447 13.6328 -0.0169392 12.5 0.000150653C11.3672 -0.0169392 9.73682 1.42447 8.91553 2.02359C8.76074 2.13589 8.62256 2.23648 8.47412 2.3439H4.6875C3.39307 2.3439 2.34375 3.39322 2.34375 4.68765V6.84292C1.73975 7.29849 1.33008 7.61783 0.897949 7.95669C0.618241 8.1759 0.392048 8.45584 0.236481 8.77535C0.0809144 9.09486 4.81351e-05 9.44556 0 9.80093L0 10.321L4.6875 13.7072V4.68765H20.3125V13.7072L25 10.321V9.80093C25 9.08121 24.6689 8.40103 24.1021 7.95669Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequests);
export default __webpack_public_path__ + "static/media/requests.6ba899da63e9729899cb669f56e117ca.svg";
export { ForwardRef as ReactComponent };